import { useMemo } from "react";
import { Option } from "../Option";

type Props = {
	items: any[]
	getItemId(item: any): string | number
	getItemText(item: any): string
	onChange(item: any): void
	isSelected?: boolean
	disabled: boolean
}

export const OptionsGroup = ({ items, getItemId, getItemText, onChange, isSelected, disabled }: Props) => {
	const content = useMemo(
		() => {
			return items.map((item) => {
				const id = getItemId(item);

				return (
					<Option
						key={id}
						item={item}
						getItemText={getItemText}
						onClick={onChange}
						isSelected={isSelected}
						disabled={disabled}
					/>
				)
			})
		},
		[items, getItemId, getItemText, onChange, isSelected, disabled]
	)

	if (disabled && !isSelected) {
		return <></>
	}

	return <>{content}</>
}
